import React, {useEffect, useState} from 'react';
import {useForm, useFormState} from 'react-hook-form';
import {View, Text, StyleSheet} from 'react-native';
import {globalFontStyle, globalStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import {globalFormStyle} from '../../../assets/GlobalStyle/globalFormStyle';
import Width from '../../../assets/Width';
import {Input} from '../../../components/core/Input';
import {
  globalConfigurableData,
  globalConst,
} from '../../../utils/globalConstant';
import {Network} from '../../../utils/network';
import {isMobile} from '../../../utils/commonMethods';
import TitleComponent from '../../event/childComponents/TitleComponent';
import {INDIA} from '../../../utils/constants';
import {useNavigation} from '@react-navigation/native';
import {useSelector} from 'react-redux';
import {Button} from '../../../components/core/Button';

const RemoveLiquidity = ({eventDetails, orderStatus, closeSheet}) => {
  const {probe} = eventDetails;
  const navigation = useNavigation();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
    control,
    formState: {errors, isSubmitting, isValid},
  } = useForm({mode: 'onChange'});
  const {dirtyFields} = useFormState({
    control,
  });
  let liquidity = probe?.liquidity;
  const lp_shares = liquidity?.investedLiqTokenCount
    ? liquidity?.investedLiqTokenCount
    : probe?.investedLiqTokenCount;

  const [yesShares, setYesShares] = useState(0);
  const [noShares, setNoShares] = useState(0);

  let userInfo = useSelector(({profile}) => profile.profileData);
  const minContacts = lp_shares;

  useEffect(() => {
    reset({
      currentShare: lp_shares?.toFixed(2),
    });
  }, [lp_shares]);

  const watchshare = watch('currentShare');

  useEffect(() => {
    getTotalAmountRecieve();
  }, [watchshare]);

  const returnShare = () => {
    if (dirtyFields.currentShare) {
      return watchshare;
    } else {
      return minContacts;
    }
  };

  const getTotalAmountRecieve = async () => {
    if (watchshare >= 0) {
      const instantSharePayload = {
        appVersion: globalConst.appVersion,
        probeid: probe.id,
        shares: parseFloat(returnShare()),
      };

      const res = await Network.getRemoveLiquidityShares(instantSharePayload);

      if (res.data.status !== 'failed') {
        setYesShares(res.data?.yesTokenReceived.toFixed(2) || 0);
        setNoShares(res.data?.noTokenReceived.toFixed(2) || 0);
        clearErrors('registerInput');
      } else {
        setError('registerInput', {type: 'custom', message: res?.data?.error});
      }
    }
  };

  let region = userInfo?.region_code ?? 'INDIA';

  const onPlaceOrder = async data => {
    if (!userInfo?.isProfileComplete) {
      isMobile() && closeSheet();
      navigation.navigate('Profile');
      return;
    }
    let inputObj = {
      appVersion: globalConst.appVersion,
      probeid: probe.id,
      shares: parseFloat(returnShare()),
    };
    if (!isSubmitting) {
      const res = await Network.RemoveLiquidity(inputObj, true);
      orderStatus(res, false, false, true);
    }
  };

  return (
    <>
      <View
        style={[
          {
            flex: 1,
            alignItems: 'stretch',
            paddingTop: isMobile() ? 0 : 15,
          },
          isMobile() ? {width: Width.width} : null,
        ]}>
        <TitleComponent eventInfo={eventDetails?.probe} />
        <View
          style={{
            borderBottomWidth: 0.75,
            borderBottomColor: globalConfigurableData.borderColor,
            marginHorizontal: 15,
          }}>
          <Text
            style={[
              styles.selectedFormTypeBlock,
              globalFontStyle.appFontSubHeading,
            ]}>
            Remove Liquidity Details
          </Text>
        </View>
        <View
          style={{
            paddingHorizontal: 15,
            paddingVertical: 5,
            justifyContent: 'space-between',
          }}>
          <View
            style={{...globalFormStyle.tableContainerRow, paddingBottom: 10}}>
            <View>
              <Text style={globalFormStyle.fieldLeft}>No of shares</Text>
            </View>
          </View>
          <Input
            name="currentShare"
            control={control}
            variant={errors?.registerInput?.type === 'custom' ? "error" : "default"}
            size="default"
            numeric={true}
            textAlign="left"
            rules={{
              required: true,
            }}
          />
          {errors?.registerInput?.type === 'custom' && (
            <Text style={globalStyle.errorText}>
              {errors.registerInput.message}
            </Text>
          )}
          <Text style={globalFormStyle.fieldLeft}>Outcome Shares Removed</Text>
          <View
            style={{
              ...globalFormStyle.tableContainerRow,
              paddingTop: 25,
              paddingBottom: 0,
            }}>
            <View>
              <Text
                style={{
                  color: globalConfigurableData.yesBtnTxt,
                  ...globalFontStyle.appFontSubText,
                }}>
                Yes x {yesShares}
              </Text>
            </View>
          </View>
          <View style={globalFormStyle.tableContainerRow}>
            <View>
              <Text
                style={{
                  color: globalConfigurableData.noBtnTxt,
                  ...globalFontStyle.appFontSubText,
                }}>
                No x {noShares}
              </Text>
            </View>
          </View>
        </View>
      </View>

      <View
        style={[
          globalStyle.customBtnParentModalStyle,
          {paddingHorizontal: 15, paddingTop: 30},
        ]}>
        <Button
          variant={isValid ? 'primary' : 'primary-inactive'}
          onPress={handleSubmit(onPlaceOrder)}
          disabled={!isValid}
        >
          Confirm
        </Button>
      </View>
    </>
  );
};

export default RemoveLiquidity;

const styles = StyleSheet.create({
  infoStyle: {
    width: 12.5,
    height: 12.5,
  },
  selectedFormTypeBlock: {
    paddingHorizontal: 10,
    borderBottomWidth: 2,
    paddingVertical: 10,
    borderBottomColor: Colors.black,
    alignSelf: 'flex-start',
  },
});
